import type {FC} from "react";
import styles from "./BannerTag.module.css";

const TAG_VARIANTS = {
  drop: "drop",
  torneo: "torneo",
  race: "race",
  nuevo: "nuevo",
  promo: "promo",
} as const;

type TagVariant = keyof typeof TAG_VARIANTS;

interface BannerTagProps {
  variant: TagVariant;
  label: string;
  className?: string;
}

const BannerTag: FC<BannerTagProps> = ({variant, label, className}) => (
  <span className={`${styles.tag} ${styles[variant]} ${className ?? ""}`}>{label}</span>
);

export default BannerTag;
export type {TagVariant, BannerTagProps};
